module.exports = __webpack_public_path__ + "9d2d1497c208bdcd6a6213cf755a6a66.pdf";